import {Bus} from '../../../event-bus'

export default{

    startGameState: (state, gameData) => {
        state.currentScore = 40000
        state.currentEnigma = 1
    },
    setScoreState: (state, score) => {
        state.currentScore = score
        Bus.$emit('alterScore')
    },
    sumScoreState: (state, score) => {
        state.currentScore = state.currentScore + score
        Bus.$emit('alterScore')
    },
    subScoreState: (state, score) => {
        state.currentScore = state.currentScore - score
        Bus.$emit('alterScore')
    },
    passCurrentEnigmaState: (state) => {
        state.currentEnigma = state.currentEnigma + 1
    },
    addExtractState: (state, extract) => {
        state.extract.push(extract)
    },
    setTimeDiscount: (state, seconds) => {
        state.timeDiscount = seconds
        // console.log('Time discountted: ', state.timeDiscount)
    },
    resetTimeDiscount: (state) => {
        // console.log('Time discount reseted')
        state.timeDiscount = 0
    } 
}